<template>
  <div class="ase-component-container">
    <div>
      <label
        class="title"
        for="account-id"
      >
        ASE Account ID
      </label>
      <tooltip
        class="ase-tooltip"
        :message="'Your ASE account ID is the same 13 character ID, including hyphens, that is found on your certificates and looks like ASE-XXXX-XXXX. You can also find your ASE ID by logging into your myASE account at <a href=\'https://portal.asecrm.com/Profile/Setup/AccountMatching.aspx\' target=\'_blank\'>www.ase.com</a>.'"
      >
        What's this?
      </tooltip>
      <label
        v-if="error"
        class="error"
      >
        {{ errorMessage }}
      </label>
    </div>
    <input
      id="account-id"
      ref="aseInput"
      v-model="code"
      type="text"
      :maxlength="characters"
      :placeholder="placeholder"
      :class="{ error: error }"
      @input="change()"
    >
  </div>
</template>

<script>
import Tooltip from '@components/singletons/tooltip';

const EXTERNAL_ID_EVENT = 'Sign Up Error - externalId';
const CLEAR_EVENT = 'Clear Sign Up Validations';

export default {
  components: { Tooltip },
  props: {
    activator: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      code: '',
      error: false,
      errorMessage: null,
    };
  },
  computed: {
    characters() {
      return this.placeholder.length;
    },
    placeholder() {
      return 'ASE-0000-0000';
    },
    valid() {
      return /^ASE-[A-Z0-9]{4}-[A-Z0-9]{4}$/.test(this.code);
    },
  },
  created() {
    this.change();
  },
  mounted() {
    this.$eventBus.$on(EXTERNAL_ID_EVENT, (message) => {
      this.error = true;
      this.errorMessage = `ASE ID ${message}`;

      this.$notify({
        duration: 10000,
        group: 'notifications',
        text: 'Please try again later or contact ASE Customer Service at (703) 669-6609 or contactus@ase.com if you have questions.',
        type: 'error',
      });
    });

    this.$eventBus.$on(CLEAR_EVENT, () => {
      this.error = false;
    });
  },
  beforeDestroy() {
    this.$eventBus.$off(EXTERNAL_ID_EVENT);
    this.$eventBus.$off(CLEAR_EVENT);
  },
  methods: {
    change() {
      let params = {
        id: this.activator.id,
        data: {
          code: this.code,
        },
      };

      this.$eventBus.$emit('activation-code-change', params);
    },
  },
};
</script>
<style lang='scss' scoped>
.ase-component-container {
  margin-top: -5px;

  > div {
    align-items: center;
    display: flex;

    .ase-tooltip {
      color: #354052;
      font-weight: $semi-bold;
      margin-left: auto;
    }

    > *:not(input) {
      padding-top: 5px;
    }

    .error {
      margin-left: rem-calc(8);
    }
  }

  input {
    border: 1px solid #dfe3e9;
    border-radius: 4px;
    box-sizing: border-box;
    color: #7f8fa4;
    font-family: monospace !important;
    font-size: rem-calc(18);
    margin: rem-calc(4) 0 rem-calc(12) 0;
    padding: rem-calc(8);
    text-transform: uppercase;
    width: 100%;

    @include focus-not-visible {
      outline: none !important;
    }

    &.error {
      border-color: red;
    }
  }
}
</style>
